module.exports = __webpack_public_path__ + "static/media/editBlack.6e4b4f8e.svg";